import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import {
  handleManagerAccept,
  handleClose,
  handleEdit,
  handleReopen,
  handleManagerReject,
  handleSuperManagerReject,
  handleSuperManagerAccept,
} from "../../../utils/AdminRequest/adminRequestHandlers";
import { AdminRequestData } from "../../../utils/AdminRequest/adminRequestTypes";
import "../Modal.css";
import ConfirmCloseModal from "./ConfirmClose";
import JournalModal from "./JournalModal";
import { authFetch } from "../../../utils/Security/authFetch";
const isAdmin = localStorage.getItem("isAdmin") === "true";
const ismanager = localStorage.getItem("ismanager") === "true";

console.log("dataaaaaaaaaaaaaaaaaaaaa", ismanager);

type Message = {
  id: number;
  username: string;
  message: string;
  date: string;
};
type Communication = {
  id: number;
  users: string;
  message: string;
  date: string;
};

type ModalProps = {
  isOpen: boolean;
  data: any;
  onClose: () => void;
};

const hiddenKeys = [
  "isaccepted",
  "isFavorite",
  "isallsite",
  "isclosed",
  "foruserid",
  "errorType",
  "isforwarded",
  "isreopened",
  "isreactivated",
];

// Sections
const ticketInfo = [
  "userid",
  "ticketId",
  "status",
  "phase",
  "ticketCreationDatetime",
  "ticketClosureDatetime",

  "adminRequestStartDatetime",
  "adminRequestCloseDatetime",
  "imapctadminRequestStartDatetime",
  "impactadminRequestCloseDatetime",
  "adminRequestResolutionTime",
  "customerapproval",
  "cabapproval",
  "closedby",
];

const statusInfo = [
  "description",
  "type",
  "subType",
  "closureCode",
  "reasonPurpose",
];
const resInfo = ["createdBy", "closedBy"];

const incInfo = ["priority"];

const relInfo = ["filePath", "relatedobject"];

const fieldLabels: { [key: string]: string } = {
  // Ticket Info
  closedBy: "Closed By",
  createdBy: "Created By",
  userid: "User ID",
  ticketId: "Ticket ID",
  status: "Status",
  phase: "Phase",
  ticketCreationDatetime: "Ticket Creation Date/Time",
  ticketClosureDatetime: "Ticket Closure Date/Time",
  adminRequestStartDatetime: "Planned Start Date/Time",
  adminRequestCloseDatetime: "Planned End Date/Time",
  imapctadminRequestStartDatetime: "Impact Planned Start Date/Time",
  imapctadminRequestCloseDatetime: "Impact Planned End Date/Time",
  impactadminRequestCloseDatetime: "Impact Planned End Date/Time",
  adminRequestResolutionTime: "Impact Period",
  customerapproval: "Customer Approval",
  cabapproval: "CAB Approval",
  typeofadminRequest: "Type of AdminRequest",
  affectedCustomer: "Customer",
  affectedNetwork: "Network",
  affectedSite: "Site",
  affectedLink: "Link",
  asset: "Asset",
  summary: "Summary",
  description: "Description",
  risk: "Risk",
  rollbackstrategy: "Rollback Strategy",
  requiredresources: "Required Resources",
  solution: "Solution",
  closureCode: "Closure Code",
  responsiblePerson: "Responsible Person",
  responsibleTeam: "Responsible Team",
  journalUpdate: "Journal Update",
  adminRequesttemplate: "AdminRequest Template",
  attachments: "Attachments",
  filePath: "File Path",
  priority: "Priority",
  relatedobject: "Related Object",
  subType: "Sub Type",
};
// const renderAttachment = (filePaths: string[] | undefined) => {
//   if (!filePaths || filePaths.length === 0) return null;

//   return (
//     <>
//       {filePaths.map((filePath, index) => {
//         const extension = filePath.split(".").pop()?.toLowerCase();
//         const url = `http://149.202.42.77:8080/${filePath.replace(/\\/g, "/")}`;

//         if (!extension) return null;

//         if (["png", "jpg", "jpeg", "gif", "bmp"].includes(extension)) {
//           return (
//             <img
//               key={index}
//               src={url}
//               alt="attachment"
//               style={{
//                 maxWidth: "100%",
//                 maxHeight: 300,
//                 display: "block",
//                 marginBottom: 10,
//               }}
//             />
//           );
//         }

//         if (extension === "pdf") {
//           return (
//             <iframe
//               key={index}
//               src={url}
//               title={`PDF-${index}`}
//               style={{
//                 width: "100%",
//                 height: "500px",
//                 border: "none",
//                 marginBottom: 10,
//               }}
//             />
//           );
//         }

//         return (
//           <a
//             key={index}
//             href={url}
//             target="_blank"
//             rel="noopener noreferrer"
//             download
//             style={{ display: "block", marginBottom: 10 }}
//           >
//             Download attachment ({extension.toUpperCase()})
//           </a>
//         );
//       })}
//     </>
//   );
// };
const formatDate = (dateStr: string): string => {
  if (!dateStr) return "";
  return dateStr.replace("T", " ").split(".")[0];
};
const downloadFile = async (path: string) => {
  try {
    if (!path) return;
    const normalizedPath = path.replace(/\\/g, "/");
    const originalFileName = normalizedPath.split("/").pop();
    if (!originalFileName) return;

    const res = await authFetch(
      `${
        config.apiBaseUrl
      }/api/adminRequests/downloadFile?path=${encodeURIComponent(path)}`
    );
    if (!res.ok) throw new Error("Failed to download file");

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = originalFileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (err) {
    console.error("Download error:", err);
  }
};

const Modal: React.FC<ModalProps> = ({ isOpen, data, onClose }) => {
  const navigate = useNavigate();
  const [selectedAdminRequest, setSelectedAdminRequest] =
    useState<AdminRequestData | null>(null);
  const [localAdminRequestData, setLocalAdminRequestData] = useState<any>(data);
  const isAdmin = localStorage.getItem("isAdmin") === "true";
  const [isForwardModalOpen, setIsForwardModalOpen] = useState(false);
  const [journalMessages, setJournalMessages] = useState<Message[]>([]);
  const [communicationMessages, setCommunicationMessages] = useState<
    Communication[]
  >([]);
  console.log(data);
  const [showConfirmClose, setShowConfirmClose] = useState(false);
  const [showAdminRequestPhase, setShowAdminRequestPhase] = useState(false);
  const [journalTitle, setJournalTitle] = useState("Add Journal");
  const isaccptedbymanager = data?.ismanageraccepted || null;
  const issupermanagerrejected = data?.issupermangerrejected || null;
  const issupermanageraccepted = data?.issupermanageraccepted || null;

  const isrejectedbymanager = data?.ismanagerrejected || null;
  const issupermanager = localStorage.getItem("issupermanager") === "true";
  const [ShowJournal, setShowJournal] = useState(false);
  const [ShowCommunication, setShowCommunication] = useState(false);
  const [fileImages, setFileImages] = useState<{
    [path: string]: string | null;
  }>({});
  const [isPauseAction, setIsPauseAction] = useState(false);
  const renderSection = (title: string, keys: string[], data: any) => (
    <div className="modal-section">
      <h3>{title}</h3>
      <div className="modal-section-content">
        {keys
          .filter((key) => {
            if (
              !isAdmin &&
              [
                "reactionPoint",
                "responseTimeToOpen",
                "responseTimeToClose",
                "reactionPoint",
                "impact",
                "priority",
                "acceptanceTime",
                "sla",
                "slaStatus",
                "ola",
                "olaStatus",
                "reactionPoint",
                "rmaCrossReference",
                "relatedobject",
                "customerComplaint",
                "customerInformed",
              ].includes(key)
            ) {
              return false;
            }
            return data[key] !== undefined && !hiddenKeys.includes(key);
          })
          .map((key, index) => (
            <div key={index} className="modal-item">
              <strong>{fieldLabels[key] || key}:</strong>
              <div className="modal-value">
                {key === "filePath" ? (
                  Array.isArray(data[key]) ? (
                    <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                      {data[key].map((path: string | null, i: number) => {
                        if (!path) return null;

                        const normalizedPath = path.replace(/\\/g, "/");
                        const fileName =
                          normalizedPath.split("/").pop() || `File${i + 1}`;
                        const ext = fileName.split(".").pop()?.toLowerCase();
                        const isImage = [
                          "png",
                          "jpg",
                          "jpeg",
                          "gif",
                          "bmp",
                          "webp",
                        ].includes(ext || "");
                        const imgUrl = fileImages[path] || null;

                        return (
                          <li key={i} style={{ marginBottom: "10px" }}>
                            {isImage && imgUrl ? (
                              <img
                                src={imgUrl}
                                alt={fileName}
                                style={{
                                  maxWidth: "100%",
                                  maxHeight: "300px",
                                  borderRadius: "5px",
                                }}
                              />
                            ) : (
                              <button
                                style={{
                                  color: "blue",
                                  textDecoration: "underline",
                                  background: "none",
                                  border: "none",
                                  cursor: "pointer",
                                }}
                                onClick={() => downloadFile(path)}
                              >
                                {fileName}
                              </button>
                            )}
                          </li>
                        );
                      })}
                    </ul>
                  ) : (
                    (() => {
                      const normalizedPath =
                        data[key]?.replace(/\\/g, "/") || "";
                      const fileName =
                        normalizedPath.split("/").pop() || "file";
                      const ext = fileName.split(".").pop()?.toLowerCase();
                      const isImage = [
                        "png",
                        "jpg",
                        "jpeg",
                        "gif",
                        "bmp",
                        "webp",
                      ].includes(ext || "");
                      const fileUrl = `${config.apiBaseUrl}/api/adminRequests/files/${fileName}`;

                      return isImage ? (
                        <img
                          src={fileUrl}
                          alt={fileName}
                          style={{
                            maxWidth: "100%",
                            maxHeight: "300px",
                            borderRadius: "5px",
                          }}
                        />
                      ) : (
                        <button
                          style={{
                            color: "blue",
                            textDecoration: "underline",
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => downloadFile(data[key])}
                        >
                          {fileName}
                        </button>
                      );
                    })()
                  )
                ) : (
                  (() => {
                    const value = data[key];
                    if (
                      value === "" ||
                      JSON.stringify(value) === "[]" ||
                      JSON.stringify(value) === "{}"
                    )
                      return "";

                    if (
                      key === "description" ||
                      key === "summary" ||
                      key === "risk" ||
                      key === "rollbackstrategy" ||
                      key === "requiredresources" ||
                      key === "solution"
                    ) {
                      return (
                        <div
                          dangerouslySetInnerHTML={{ __html: value }}
                          style={{ whiteSpace: "normal" }}
                        />
                      );
                    }

                    if (Array.isArray(value)) return value.join(", ");
                    if (typeof value === "string") {
                      if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/.test(value))
                        return formatDate(value);
                      return value;
                    }

                    return JSON.stringify(value, null, 2);
                  })()
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
  useEffect(() => {
    if (isOpen) {
      setLocalAdminRequestData(data);
      fetchMessages();
      fetchCommunication();
    }
  }, [isOpen, data]);

  const fetchMessages = async () => {
    if (!data?.ticketId) return;
    const res = await authFetch(
      `${config.apiBaseUrl}/api/messages/ticket/${data.ticketId}`
    );
    if (res.ok) setJournalMessages(await res.json());
  };

  const fetchCommunication = async () => {
    if (!data?.ticketId) return;
    const res = await authFetch(
      `${config.apiBaseUrl}/api/communications/ticket/${data.ticketId}`
    );
    if (res.ok) setCommunicationMessages(await res.json());
  };

  if (!isOpen) return null;

  const fetchUpdateAdminRequests = async (): Promise<AdminRequestData> => {
    const res = await authFetch(
      `${config.apiBaseUrl}/api/adminRequests/${data.ticketId}`
    );
    return await res.json();
  };
  const isAccepted = data?.isaccepted;
  const isClosed = data?.isclosed;
  const handleForward = (data: AdminRequestData) => {
    setSelectedAdminRequest(data);
    setIsForwardModalOpen(true);
  };
  const confirmClose = async () => {
    setShowConfirmClose(false);
    onClose();
    await new Promise((resolve) => setTimeout(resolve, 4000));
    const updatedData = await fetchUpdateAdminRequests();
    await handleClose(updatedData, fetchMessages);
  };

  const addcommunication = () => {
    setShowCommunication(false);
    onClose();
  };
  console.log("ismanagerrrrrrrr", issupermanager);
  return (
    <>
      {showConfirmClose && (
        <ConfirmCloseModal
          data={data}
          onConfirm={confirmClose}
          onCancel={() => setShowConfirmClose(false)}
        />
      )}

      {ShowJournal && (
        <JournalModal
          data={data}
          title={journalTitle}
          onConfirm={async (journalText: string) => {
            await authFetch(`${config.apiBaseUrl}/api/messages`, {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({
                ticketId: data.ticketId,
                message: journalText,
              }),
            });

            if (isPauseAction) {
              setJournalTitle("Pause Request (Add Journal)");
            }

            setShowJournal(false);
            fetchMessages();
            setIsPauseAction(false);
          }}
          onCancel={() => {
            setShowJournal(false);
            setIsPauseAction(false);
          }}
        />
      )}

      <div className="modal-overlay">
        <div className="modal-content">
          <div
            className="modal-top-buttons"
            style={{
              position: "sticky",
              top: -32,
              backgroundColor: "#fff",
              zIndex: 100,
              padding: "10px",
              display: "flex",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            {" "}
            {!isClosed && (
              <button
                onClick={() => navigate(`/adminRequest-edit/${data.ticketId}`)}
              >
                Edit
              </button>
            )}
            {!isAccepted &&
              ismanager &&
              !isaccptedbymanager &&
              !isrejectedbymanager && (
                <button
                  onClick={() => handleManagerAccept(data, fetchMessages)}
                >
                  Accept
                </button>
              )}
            {!isAccepted &&
              ismanager &&
              !isrejectedbymanager &&
              !isaccptedbymanager && (
                <button
                  onClick={() => handleManagerReject(data, fetchMessages)}
                >
                  Reject
                </button>
              )}
            {(!isAccepted &&
              issupermanager &&
              !issupermanagerrejected &&
              !issupermanageraccepted &&
              isrejectedbymanager) ||
              (isaccptedbymanager && (
                <button
                  onClick={() => handleSuperManagerAccept(data, fetchMessages)}
                >
                  Accept
                </button>
              ))}
            {(!isAccepted &&
              issupermanager &&
              !issupermanagerrejected &&
              !issupermanageraccepted &&
              isrejectedbymanager) ||
              (isaccptedbymanager && (
                <button
                  onClick={() => handleSuperManagerReject(data, fetchMessages)}
                >
                  Reject
                </button>
              ))}
            {isAccepted && !isClosed && isAdmin && (
              <>
                <button disabled>Already Accepted</button>
                <button
                  onClick={() => {
                    setIsPauseAction(true);
                    setShowJournal(true);
                  }}
                >
                  Pause
                </button>
                <button onClick={() => setShowConfirmClose(true)}>Close</button>
              </>
            )}
            {isAdmin && (
              <>
                <button onClick={() => setShowConfirmClose(true)}>Close</button>
              </>
            )}
            {isClosed && isAdmin && (
              <button onClick={() => handleReopen(data, fetchMessages)}>
                Reopen
              </button>
            )}
            <button onClick={onClose}>X</button>
          </div>

          <h2
            style={{
              position: "sticky",
              top: 16, // slightly below the buttons
              backgroundColor: "#fff",
              zIndex: 99,
              margin: 0,
              padding: "10px 0",
            }}
          >
            AdminRequest Details
          </h2>
          <div className="modal-body">
            {renderSection("Request Information", ticketInfo, data)}
            {renderSection("Request Severity", incInfo, data)}
            {renderSection("Request Details", statusInfo, data)}
            {isAdmin && renderSection("Responsibility", resInfo, data)}
          </div>

          <div className="messages-container">
            {isAdmin && (
              <div className="journal">
                {isAdmin && (
                  <button
                    onClick={() => {
                      setIsPauseAction(false);
                      setShowJournal(true);
                      setJournalTitle("Add Journal");
                    }}
                  >
                    Add Journal
                  </button>
                )}
                <h3>Journal</h3>
                <ul style={{ listStyle: "none", padding: 0 }}>
                  {[...journalMessages]
                    .sort(
                      (a, b) =>
                        new Date(b.date).getTime() - new Date(a.date).getTime()
                    )
                    .map((msg) => (
                      <li
                        key={msg.id}
                        style={{
                          marginBottom: "1rem",
                          wordBreak: "break-word",
                        }}
                      >
                        <strong>{msg.username}</strong>:&nbsp;
                        <span
                          dangerouslySetInnerHTML={{ __html: msg.message }}
                          style={{
                            display: "inline-block",
                            maxWidth: "100%",
                            wordWrap: "break-word",
                            overflowWrap: "break-word",
                          }}
                        />
                        <br />
                        <small>{new Date(msg.date).toLocaleString()}</small>
                      </li>
                    ))}
                </ul>
              </div>
            )}
            <div className="journal">
              <button onClick={() => setShowCommunication(true)}>
                Add Communication
              </button>

              <h3>Communication</h3>
              <ul>
                {[...communicationMessages]
                  .sort(
                    (a, b) =>
                      new Date(b.date).getTime() - new Date(a.date).getTime()
                  )
                  .map((msg) => (
                    <li key={msg.id}>
                      <strong>{msg.users}</strong>: {msg.message}
                      <br />
                      <small>{new Date(msg.date).toLocaleString()}</small>
                    </li>
                  ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
